export const patchNewEmail = (welletContext, email) => {
  try {
    const response = welletContext.apis.tickets.patch(
      `/users/email?newEmail=${email}`
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};
